import React from 'react';
import { getProductImage } from '@beacharound/beacharound-ui-helpers';
import { Tile } from '@beacharound/beacharound-ui';

export default function ProductItem({ item, daysNum, hideImage, hidePrice }) {
    const price = Math.floor(item.price / daysNum).toFixed(2)
    const priceComparison = item.priceComparison && Math.floor(item.priceComparison / daysNum).toFixed(2);

    let text;
    if (!hidePrice) {
        text = item.price ? `A partire da ${priceComparison ? `<strike>${priceComparison} €</strike> ` : ""}${price}€ al giorno` : "";
    }

    return (
        <Tile
            highlight={priceComparison ? "In sconto!" : ""}
            image={item.type && !hideImage && getProductImage(item.type)}
            title={item.name}
            text={text}
        />
    );
}